export const levelList = [
    {label: 'اطلاع', value: 1},
    {label: 'هشدار', value: 2},
    {label: 'اخطار', value: 3}]

